import routes from './routes';

class RouteService {
  extension;

  paths;

  constructor(routes) {
    this.extension = routes.extension;
    this.paths = {};
    Object.entries(routes.paths).forEach(([key, { prefix, uris }]) => {
      if (key === '_') {
        Object.entries(uris).forEach(([lowerKey, uri]) => {
          this.paths[lowerKey] = this.createFullUri(null, uri, this.extension);
        });
      } else {
        Object.entries(uris).forEach(([lowerKey, uri]) => {
          if (!this.paths[key]) this.paths[key] = {};
          this.paths[key][lowerKey] = this.createFullUri(
            prefix,
            uri,
            this.extension,
          );
        });
      }
    });
  }

  createFullUri(prefix, uri, extension) {
    if (!prefix) return `${uri}.${extension}`;
    return `${prefix}/${uri}.${extension}`;
  }
}

const routeService = new RouteService(routes);
export default routeService.paths;
